define('common/module/query/Serum.Query',[],function(){

  'use strict';

  function currentQs() {
    try {
      return JSON.parse('{"' + decodeURI(location.search.substring(1)||'=').replace(/&{2,}/,'&').replace(/&$/,'').replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}'); // eslint-disable-line no-div-regex
    } catch(e) {
      return {};
    }
  }

  return {
    qs: currentQs(),
    currentQs: currentQs
  };


});
